import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_BUTTON_CONFIG = defineFcm('psf_share_button_config')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'enum',
				values: [
					'copy',
					'facebook',
					'instagram',
					'whatsapp',
					'twitter',
					'email',
					'facebookMessenger',
					'sms',
					'line',
					'nextdoor',
					'vk',
					'mobileNativeShare',
					'reddit',
					'instagramStories',
					'tiktok',
				] as const,
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-site-platform-payments',
		// Read server-side only (getChannels.ts on PSF contexts). `corgi-front-end`
		// is kept for now to avoid breaking the FE schema field
		// `FeatureConfigs.psfShareButtonConfig` while older clients may still query
		// it. Drop once those clients have rolled over.
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF share page',
		description: 'Custom share buttons on PSF share page',
		import: false,
		template: [
			'copy',
			'facebook',
			'instagram',
			'whatsapp',
			'twitter',
			'email',
			'facebookMessenger',
			'sms',
			'line',
			'nextdoor',
			'vk',
			'mobileNativeShare',
			'reddit',
		],
	});
